import { gql } from '@apollo/client';

const DELETE_STUDIES_MUTATION = gql`
  mutation deleteStudies($studyIds: [ID]!) {
    deleteStudies(studyIds: $studyIds) {
      isSuccess
      message
    }
  }
`;

export default DELETE_STUDIES_MUTATION;
